import { kebabCase, toLower } from 'lodash'

export const createFullIndexUrl = (
  prefix,
  relativePath,
  endingSlash = true
) => {
  if (prefix === 'blog') {
    return `/blog/${relativePath}${endingSlash ? '/' : ''}`
  }

  if (prefix === 'tutorial') {
    return `/community/tutorials/${relativePath}${endingSlash ? '/' : ''}`
  }

  if (prefix === 'media') {
    return `/press/media/${relativePath}${endingSlash ? '/' : ''}`
  }
}

export const createFullSingleUrl = (
  prefix,
  relativePath,
  endingSlash = true
) => {
  let pathPrefix = ''

  if (prefix === 'tutorial') {
    pathPrefix = '/community/tutorials'
  } else if (prefix === 'blog') {
    pathPrefix = `/${prefix}`
  } else if (prefix === 'chaos-monkey') {
    pathPrefix = `/${prefix}`
  } else if (prefix === 'chaos-monkey-alternatives') {
    pathPrefix = `/chaos-monkey/${prefix}`
  } else if (prefix === 'docs') {
    pathPrefix = `/${prefix}`
  } else if (prefix === 'site-reliability-engineering') {
    pathPrefix = `/${prefix}`
  } else if (prefix === 'case-studies') {
    pathPrefix = '/customers'
  } else if (prefix === 'webinars') {
    pathPrefix = `/${prefix}`
  } else if (prefix === 'events') {
    pathPrefix = `/${prefix}`
  } else if (prefix === 'mdx-docs') {
    pathPrefix = `/${prefix}`
  }

  return `${pathPrefix}/${relativePath}${endingSlash ? '/' : ''}`
}

export const getArticleType = (node) => {
  if (node.fileAbsolutePath.includes('/src/posts/')) {
    return 'blog'
  }

  if (node.fileAbsolutePath.includes('/src/tutorials/')) {
    return 'tutorial'
  }

  if (node.fileAbsolutePath.includes('/src/static-pages/')) {
    return 'static-pages'
  }

  if (node.fileAbsolutePath.includes('/src/webinars/')) {
    return 'webinars'
  }

  if (node.fileAbsolutePath.includes('/src/events/')) {
    return 'events'
  }

  if (node.fileAbsolutePath.includes('/src/site-reliability-engineering/')) {
    return 'site-reliability-engineering'
  }

  if (node.fileAbsolutePath.includes('/src/case-studies/')) {
    return 'case-studies'
  }

  if (node.fileAbsolutePath.includes('/src/media/')) {
    return 'media'
  }

  if (node.fileAbsolutePath.includes('/src/mdx-docs/')) {
    return 'mdx-docs'
  }

  if (
    node.fileAbsolutePath.includes('/src/whitepaper-landing-pages/') ||
    node.fileAbsolutePath.includes('/src/sign-up-landing-pages/') ||
    node.fileAbsolutePath.includes('/src/demo-landing-pages')
  ) {
    return 'landing-page'
  }

  // Make sure we do this one first so more descriptive matches can go first
  if (
    node.fileAbsolutePath.includes(
      '/src/chaos-monkey/chaos-monkey-alternatives/'
    )
  ) {
    return 'chaos-monkey-alternatives'
  }

  if (node.fileAbsolutePath.includes('/src/chaos-monkey/')) {
    return 'chaos-monkey'
  }

  if (node.fileAbsolutePath.includes('/src/docs/articles/')) {
    return 'docs'
  }
}

// This is used within our Resources section
export const getArticleLabel = (type) => {
  switch (type) {
    case 'blog':
      return 'Blog Posts'

    case 'tutorial':
      return 'Tutorials'

    case 'webinars':
      return 'Webinars'

    case 'events':
      return 'Events'

    case 'case-studies':
      return 'Case Studies'

    case 'chaos-monkey':
    case 'chaos-monkey-alternatives':
    case 'site-reliability-engineering':
      return 'Microsites'

    case 'landing-page':
      return 'Whitepapers'

    case 'media':
      return 'Media'

    case 'docs':
      return 'Docs'

    default:
      return 'Page'
  }
}

export const createCategoryMap = (edges) => {
  const categories = {}

  edges.forEach(({ node }) => {
    if (node.frontmatter.categories) {
      node.frontmatter.categories.forEach((category) => {
        if (!categories[category]) {
          categories[category] = {
            name: category,
            slug: `category/${kebabCase(toLower(category))}`,
            nodes: [],
          }
        }

        categories[category].nodes.push(node)
      })
    }
  })

  return categories
}

export const createAuthorMap = (edges) => {
  const authors = {}

  edges.forEach(({ node }) => {
    const { author } = node.frontmatter

    if (author) {
      if (!authors[author]) {
        authors[author] = {
          name: author,
          slug: `author/${kebabCase(toLower(author))}`,
          nodes: [],
        }
      }

      authors[author].nodes.push(node)
    }
  })

  return authors
}

// Purposely not including Netlify-only redirects since our internal link checker will attempt to use React's internal router to push to these pages; even though they don't exist (as-is) on the site.
// @NOTE /events has some special casing due to us supporting both a top-level server-side redirect /events/ -> new url and /events/my-event being an internal, Gatsby link
export const redirectPathsRegex = /(\/chaos-conf-2019|\/kubecon|\/slack-invite|\/free|\/events[/]($)|\/webinars)[/]?/
export const domainRegex = /http[s]*:\/\/[www.]*gremlin\.com(?!\/chaos-conf-2019|\/kubecon|\/slack-invite|\/free|\/events[/]?($)|\/webinars)[/]?/

export const defaultBlogFeaturedImage =
  'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597256387/Blog/Revamp/Generic-1.png'
export const defaultTutorialFeaturedImage =
  'https://res.cloudinary.com/gremlin/image/upload/t_default/Internal/default-featured-image.png'
export const defaultOGImage =
  'https://res.cloudinary.com/gremlin/image/upload/t_default/Internal/default-og-image.png'
